import { render } from "./ProductSaveRecommendPage.vue?vue&type=template&id=5608286b"
import script from "./ProductSaveRecommendPage.vue?vue&type=script&lang=js"
export * from "./ProductSaveRecommendPage.vue?vue&type=script&lang=js"
script.render = render

export default script